import { ChildModel, ModelBase } from 'store/model-base';
import { StatementSnapshot } from './statement-snapshot';

export class StatementList extends ModelBase {
    public static storeName: string = 'statementList';

    public statements: StatementSnapshot[];

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'statements',
            model: StatementSnapshot
        }];
    }
}
